import moment from 'moment';
import React, { useState, useEffect } from 'react';
import Avatar from '../Avatar';
import { useSelector } from 'react-redux';

const MessagesRepeater = ({
  notes,
  user,
  onSendEmailNotification,
  onImageClicked,
}) => {
  const tabSelections = useSelector((state) => state.tabSelections);
  const { allowedTabList } = tabSelections;
  const [isOpen, setisOpen] = useState(false);
  const [allowVideoChat, setAllowVideoChat] = useState(true);
  const IsOpen = () => setisOpen(true);

  let theme = localStorage.getItem('theme');

  useEffect(() => {
    const videoChat = allowedTabList.filter(
      (item) => item.name === 'Video Chat'
    )[0];
    if (videoChat !== undefined) {
      setAllowVideoChat(true);
    } else {
      setAllowVideoChat(false);
    }
  }, []);

  return (
    <div>
      {notes.map((note, x) => (
        <div key={x} className="messages__message">
          <div className="messages__author">
            <div className="messages__avatar">
              <div
                onClick={
                  note.sentByImage ? IsOpen : () => setisOpen({ isOpen: false })
                }
              >
                <Avatar size="badge" url={note.sentByImage} />
              </div>
              {note.sentBy === user.id
                ? null
                : allowVideoChat === true &&
                  user.roles[0].role.name !== 'Realtor' && (
                    <div
                      className="messages__vedio"
                      onClick={(e) => {
                        e.stopPropagation(); // Stop event propagation.
                        onSendEmailNotification(note);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <br />
                      <img
                        src={'/assets/icon-chat.png'}
                        className="messages__chatIcon"
                        alt="avatar"
                      />
                    </div>
                  )}
            </div>
            <div>
              <div className="messages__username">{note.sentByName}</div>
              <div
                className="messages__body"
                style={{ whiteSpace: 'pre-line' }}
              >
                {note.message}
              </div>
              {note.fileName ? (
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() => onImageClicked(x, note)}
                >
                  {note.fileName}
                </div>
              ) : null}
              <div className="messages__date">
                {moment(note.sentOn).format('MM/DD/YYYY hh:mm A')}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MessagesRepeater;
